export default "__VITE_ASSET__a301f5a8__"